// Generated by ReScript, PLEASE EDIT WITH CARE


var allocation_radius_info_icon = "Haversine or aerial radius beyond which drivers will be filtered out. Centre of circle is the pickup point.";

var dry_run_info_icon = "If driver is beyond threshold dry run x (estimated dry run > x km), then dry run ratio is applied where, ratio*estimated dry run > trip distance. Drivers who fulfil this logic get filtered out. Uses actual on road route and not haversine";

var max_dry_run_info_icon = "On road distance from current driver location to pickup beyond which drivers will be filtered out";

var create_zonal_campaign_modal_box = "You are about to create a new zonal campaign. Are you sure you wish to continue?";

var create_cluster_campaign_modal_box = "You are about to create a new cluster campaign. Are you sure you wish to continue?";

var zonal_campaign_sent_for_approval = "Zonal Campaign has been successfully created and sent for approval";

var cluster_campaign_sent_for_approval = "Cluster Campaign has been successfully created and sent for approval";

var click_remove_to_select_a_different_filter = "Note: If you wish to select a different filter please click remove";

var only_one_filter_can_be_selected = "Note: Only 1 filter can be selected for campaign creation";

export {
  allocation_radius_info_icon ,
  dry_run_info_icon ,
  max_dry_run_info_icon ,
  create_zonal_campaign_modal_box ,
  create_cluster_campaign_modal_box ,
  zonal_campaign_sent_for_approval ,
  cluster_campaign_sent_for_approval ,
  click_remove_to_select_a_different_filter ,
  only_one_filter_can_be_selected ,
  
}
/* No side effect */
